<!--
 * @Description:
 * @Date: 2019-03-29 13:49:26
 -->
<template>
  <div id="app">
    <keep-alive :include="keepAlive">
      <router-view v-if="show" />
    </keep-alive>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import store from '@/qiankun/store';
import NProgress from 'nprogress';
import { listenRouterChange } from '@/qiankun/utils/index';
import checkMaintenance from '@/Mixin/checkMaintenance';

export default {
  name: 'App',
  mixins: [checkMaintenance],
  computed: {
    ...mapState({
      breadcrumbList: state => state.breadcrumb.breadcrumbList
    }),
    // 获取应用间的store
    ignore() {
      let name = store.getGlobalState('ignore');
      console.log('ignore:', name);
      return name;
    }
  },
  watch: {
    isLoading(val) {
      if (val) {
        NProgress.start();
      } else {
        this.$nextTick(() => {
          NProgress.done();
        });
      }
    }
  },
  data() {
    return {
      closeLoopDebugger: false,
      show: true,
      keepAlive: ['record'],
      isLoading: true,
      current: '/qqq'
    };
  },
  provide() {
    return {
      forceReload: this.forceReload
    };
  },
  methods: {
    forceReload() {
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  },
  mounted() {
    // qiankun: 监听路由，获取当前子应用
    listenRouterChange.call(this);
  },
  async created() {
    NProgress.start();
    // let _this = this;
    // window.onbeforeunload = function() {
    //   sessionStorage.setItem(
    //     "breadcrumbList",
    //     JSON.stringify(_this.breadcrumbList)
    //   );
    // };

    // 调试模式 自动打断点
    // let check = function() {
    //   function doCheck(a) {
    //     if (('' + a / a)['length'] !== 1 || a % 20 === 0) {
    //       (function() {}['constructor']('debugger')());
    //     } else {
    //       (function() {}['constructor']('debugger')());
    //     }
    //     doCheck(++a);
    //   }

    //   try {
    //     doCheck(0);
    //   } catch (err) {}
    // };
    setInterval(() => {
      let closeLoopDebugger = this.$route.query.closeLoopDebugger;
      if (process.env.NODE_ENV === 'production' && !closeLoopDebugger) {
        // this.closeLoopDebugger = true;
        // check();
      }
    }, 4000);
  }
};
</script>

<style lang="scss">
@import '~@/styles/list-page.scss';
@import '~@/styles/form-page.scss';
@import '~@/styles/chart.scss';
@import '~@/styles/global.scss';
@import '~@/styles/unqualified.scss';

@import './assets/css/media.css';

.form-item-flex {
  .el-input--prefix.hidden-ss {
    position: relative;
    font-size: 14px;

    &::after {
      pointer-events: none;
      content: ' ';
      width: 3em;
      display: block;
      background: #fff;
      /*background: yellow;*/
      position: absolute;
      transform: translateY(-50%);
      top: 50%;
      left: 68px;
      height: 2em;
      /*z-index: 200;*/
    }
  }
  .el-input--prefix.is-disabled.hidden-ss {
    &::after {
      background: #f6f7fa;
    }
  }
}

body {
  min-width: 1200px;
}

.el-button--primary {
  background-color: #5a9cf8;
  border-color: #5a9cf8;
}

.hand {
  cursor: pointer;
}

// 选中
.ysh-active {
  background: #409eff;
  color: #fff;
}

// 单个上传样式
.upload-one {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 350px;
    height: 100px;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 100px;
    text-align: center;
  }

  .avatar {
    width: 350px;
    height: 100px;
    display: block;
  }
}
.upload-two {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 110px;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 110px;
    line-height: 110px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}

// 上传文件名长度
.el-upload-list {
  width: 300px;
}

.el-button {
  line-height: 1 !important;
}

// nav
.el-menu.el-menu--horizontal {
  border: none;
}

.el-tabs__nav {
  border: none !important;
}

.dialog {
  .el-dialog {
    /*弹窗继承字体样式*/
    font-size: 14px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
    /*width: 550px;*/
    width: 86vw;
    /*标题样式*/
    .el-dialog__header {
      background-color: #5a9cf8;
      padding: 0px;
      height: 51px;
      display: flex;
      justify-content: center;
      align-items: center;

      .el-dialog__title {
        font-size: 18px;
        color: #ffffff;
        line-height: 25px;
      }
    }

    /*输入框后面加<元>*/
    .el-dialog__body {
      padding: 30px 46px 8px;
      border-bottom: 1px #dfe1e6 solid;

      .el-form-item {
        margin-bottom: 15px;
      }

      .rmb-yuan {
        /*需打款公司 lable样式*/
        .el-form-item__label {
          color: #333333;
          height: 40px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          line-height: 20px;
        }

        .el-input {
          text-align: left;

          &:after {
            display: inline;
            content: '元';
            margin-left: 7px;
          }
        }
      }
      /*input输入框大小*/
      .el-input {
        width: 55%;
      }
    }

    /*底部按钮居中和大小*/
    .el-dialog__footer {
      height: 89px;
      padding: 0;
      display: flex;
      justify-content: center;

      .dialog-footer {
        align-self: center;

        .el-button {
          width: 155px;
          height: 39px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.l-common-title {
  font-size: 20px;
  font-weight: 500;
  color: #2e2f2f;
  line-height: 24px;
  position: relative;
  padding-left: 16px;
  &::before {
    content: '';
    width: 8px;
    height: 24px;
    background: #1989fa;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
  }
}
// 放大查看图片
.el-image-viewer__wrapper {
  font-size: 32px;
}
.el-icon-circle-close {
  color: #fff;
}
// xrkDialog 通用btn
.xrk-dialog__btns {
  display: flex;
  justify-content: center;
  margin-top: 15px;
  button:nth-of-type(2) {
    margin-left: 100px;
  }
}
// 文字提示
.custom-tooltip {
  max-width: 400px;
}

// 异步下拉 多选框
.search-select.custom-multiple-select {
  width: 205px !important;
  max-width: 205px !important;
  .el-select__tags {
    &-text {
      display: inline-block;
      max-width: 70px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .el-tag__close.el-icon-close {
    top: -7px;
  }
}
</style>
